import { Component, HostListener, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { LocalizedRoutesService } from '../../../core/routing/localized-routes.service';
import { CookieConsentService } from '../../../core/services/cookie-consent.service';

@Component({
  selector: 'app-cookie-banner',
  standalone: true,
  imports: [RouterLink, TranslatePipe],
  templateUrl: './cookie-banner.html',
  styleUrl: './cookie-banner.css'
})
export class CookieBannerComponent {
  readonly paths = inject(LocalizedRoutesService);
  readonly consent = inject(CookieConsentService);

  readonly customizeOpen = signal(false);
  readonly analyticsEnabled = signal(false);

  openCustomize(): void {
    this.analyticsEnabled.set(this.consent.preferences()?.analytics ?? false);
    this.customizeOpen.set(true);
  }

  closeCustomize(): void {
    this.customizeOpen.set(false);
  }

  saveCustom(): void {
    this.consent.save({ analytics: this.analyticsEnabled() });
    this.customizeOpen.set(false);
  }

  rejectAll(): void {
    this.consent.rejectAll();
    this.customizeOpen.set(false);
  }

  acceptAll(): void {
    this.consent.acceptAll();
    this.customizeOpen.set(false);
  }

  toggleAnalytics(): void {
    this.analyticsEnabled.update((value) => !value);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.customizeOpen()) {
      this.closeCustomize();
    }
  }
}
